import React from "react";
import { isMobile } from "react-device-detect";
import { WebLeft, WebWidth } from "../../../../config/config";

export default function QuickCartButton({
  totalPrice,
  itemCount,
  onClick,
}) {
  const horizontalPadding = 14;

  return (
    <button
      id="QuickCartBTN"
      style={{
        position: "fixed",
        backgroundColor: "#453f3f",
        bottom: "52px",
        zIndex: 99,
        padding: "10px 12px",
        border: "none",
        outline: "none",
        borderRadius: "999px",
        fontSize: 16,
        color: "white",
        left: isMobile ? "50%" : `calc(${WebLeft} + ${horizontalPadding}px)`,
        transform: isMobile ? "translateX(-50%)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "14px",
        width: isMobile
          ? "min(420px, calc(100% - 28px))"
          : `calc(${WebWidth}px - ${horizontalPadding * 2}px)`,
        maxWidth: isMobile ? "420px" : `calc(${WebWidth}px - ${horizontalPadding * 2}px)`,
        boxShadow: "0 8px 18px rgba(0, 0, 0, 0.18)",
      }}
      onClick={onClick}
    >
      <span
        style={{
          fontSize: "17px",
          fontWeight: "700",
          lineHeight: 1,
        }}
      >
        {itemCount} {itemCount === 1 ? "Item" : "Items"}
      </span>

      <span
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.18)",
          color: "white",
          padding: "8px 14px",
          borderRadius: "999px",
          fontSize: "15px",
          fontWeight: "700",
          lineHeight: 1,
          minWidth: "fit-content",
        }}
      >
        {totalPrice}
      </span>
    </button>
  );
}
